import { LoaderCircle } from 'lucide-react';

export default function LoadingIndicator({
  label = 'Cargando...',
  className = '',
  compact = false,
  fullScreen = false,
}) {
  const size = compact ? 'h-4 w-4' : 'h-6 w-6';
  const spacing = 'gap-2';
  const wrapper = fullScreen
    ? 'min-h-screen-safe bg-transparent flex items-center justify-center'
    : compact
      ? 'flex items-center justify-center'
      : 'flex min-h-24 items-center justify-center';

  return (
    <div className={`${wrapper} ${className}`} role="status" aria-live="polite">
      <div className={`flex flex-col items-center ${spacing} text-center`}>
        <LoaderCircle className={`${size} animate-spin text-muted-foreground`} strokeWidth={1.8} />
        <p className={`${compact ? 'text-xs' : 'text-sm'} font-medium text-muted-foreground`}>{label}</p>
      </div>
    </div>
  );
}
